import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Navimumbaitopunecabs() {



  const cardData =
  {
    keyword: ' Navi Mumbai to Pune Cab',
    heading: 'Sai Trupti Cabs: Navi Mumbai to Pune Cab',
    headingDescription: 'Sai Trupti Cabs provides reliable and comfortable Navi Mumbai to Pune cab services, giving you a smooth and stress-free journey between the two cities. Our fleet of well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles ensures maximum comfort from the moment you’re picked up in Navi Mumbai until you arrive in Pune. Our professional and background-verified chauffeurs guarantee punctual pickups, courteous service, and safe driving throughout the approx. 2–3 hour trip. With transparent one-way fares, flexible bookings, and 24 × 7 customer support, Sai Trupti Cabs makes intercity travel seamless and affordable. Experience a convenient and hassle-free ride from Navi Mumbai to Pune with comfort, safety, and reliability — your trusted partner for cab services.',

    top: 'Top Places to Visit in Mumbai with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as the majestic symbol of Mumbai’s colonial heritage and cosmopolitan spirit. Built in 1924 overlooking the Arabian Sea, this grand basalt arch commemorates the visit of King George V and Queen Mary to India. Tourists and locals flock here to enjoy ferry rides, photography, and sunset views that illuminate the sea with golden hues. Across the road, the iconic Taj Mahal Palace Hotel adds a touch of royal charm. Whether you’re arriving by boat or simply strolling along the promenade, the Gateway captures Mumbai’s essence — welcoming, historic, and endlessly vibrant."
  },
  {
    "title": "Marine Drive",
    "description": "Famously known as the Queen’s Necklace, Marine Drive is a 3.6-kilometer boulevard that curves gracefully along the Arabian Sea. It connects Nariman Point to Girgaum Chowpatty, offering one of the most scenic evening walks in India. As night falls, the streetlights resemble a shimmering pearl necklace — a breathtaking sight that defines Mumbai’s skyline. Locals jog here at dawn, couples watch the sunset, and artists find inspiration in its endless horizon. Marine Drive is more than just a road; it’s the heartbeat of Mumbai, where the sea breeze whispers stories of dreams and resilience."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "Chhatrapati Shivaji Maharaj Terminus, formerly Victoria Terminus, is Mumbai’s most iconic architectural marvel and a UNESCO World Heritage Site. Built in 1887, this Gothic Revival-style railway station features domes, stained glass windows, and ornate carvings that blend Victorian aesthetics with Indian motifs. As thousands of commuters pass through its grand corridors daily, the station pulsates with life and energy. Its intricate details tell tales of colonial craftsmanship and cultural fusion. CSMT is not just a transport hub — it’s a living museum of Mumbai’s history, art, and unstoppable motion."
  },
  {
    "title": "Elephanta Caves",
    "description": "Located on Elephanta Island, about 10 kilometers from Mumbai’s shores, the Elephanta Caves are a UNESCO-listed treasure of ancient Indian art. Carved between the 5th and 7th centuries, the caves are dedicated to Lord Shiva and feature awe-inspiring sculptures like the majestic Trimurti — a three-headed form symbolizing creation, preservation, and destruction. Visitors reach the island via ferry from the Gateway of India, enjoying sea breezes and panoramic views of Mumbai’s skyline. The caves’ dark chambers, timeless artistry, and tranquil atmosphere make them a must-visit blend of spirituality and heritage."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach, Mumbai’s most famous shoreline, stretches over six kilometers along the city’s western suburbs. Every evening, it transforms into a carnival of street food, laughter, and golden sunsets. Vendors serve mouth-watering pav bhaji, bhel puri, and kulfi as families and tourists relax by the waves. The beach is also known for its proximity to Bollywood celebrities’ homes, including Amitabh Bachchan’s residence. Whether you’re enjoying a morning jog, a kite-flying session, or simply watching the sea kiss the sky, Juhu Beach offers a perfect snapshot of Mumbai’s vibrant coastal life."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah is a stunning white marble mosque and tomb located on a small islet off the coast of Worli, connected to the city by a narrow causeway. Built in the 15th century, it enshrines the tomb of the revered Sufi saint Pir Haji Ali Shah Bukhari. At high tide, the path appears submerged, making the shrine seem as if it floats on the sea. The rhythmic sound of waves, the fragrance of incense, and the sight of devotees from all faiths create an unforgettable spiritual experience. It stands as a beacon of unity, faith, and Mumbai’s cultural harmony."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Spread across 100 square kilometers, Sanjay Gandhi National Park is one of the few wildlife sanctuaries located within a major city. Home to leopards, deer, and hundreds of bird species, the park offers nature trails, boating, and scenic viewpoints. Inside the park lie the ancient Kanheri Caves, dating back over 2,000 years, carved by Buddhist monks as prayer halls and monasteries. The park is a haven for trekkers and nature lovers seeking an escape from Mumbai’s urban rush. With its fresh air, lush forests, and spiritual calm, it is the city’s green lung and natural retreat."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "The Shree Siddhivinayak Temple in Prabhadevi is one of Mumbai’s most powerful spiritual centers dedicated to Lord Ganesha. Built in 1801, the temple’s gold-plated dome and intricately carved idol attract devotees from across the world — from film stars to politicians and families seeking blessings. The aura of devotion fills the air, especially during Ganesh Chaturthi when the temple glows with lights and chants. Prayers offered here are believed to fulfill wishes, making it a sacred cornerstone of Mumbai’s faith, prosperity, and divine protection."
  },
  {
    "title": "Colaba Causeway Market",
    "description": "Colaba Causeway is Mumbai’s most vibrant and artistic street market, stretching through one of the city’s oldest neighborhoods. It’s a paradise for shoppers and explorers alike, offering everything from ethnic jewelry and leather goods to antique décor and street fashion. Amid the bustling stalls are heritage cafés like Leopold and Café Mondegar, where artists and travelers share stories over coffee. The market’s colonial charm, creative pulse, and endless variety make it a must-visit stop for anyone wanting to experience Mumbai’s cosmopolitan soul."
  },
  {
    "title": "Bandra–Worli Sea Link",
    "description": "The Bandra–Worli Sea Link is a breathtaking engineering marvel that connects South Mumbai to its western suburbs. This eight-lane cable-stayed bridge stretches gracefully over the Arabian Sea, cutting travel time and offering one of the most spectacular drives in India. At night, the bridge lights up like a string of diamonds against the skyline. Driving across it during sunset reveals panoramic views of the sea and city, symbolizing Mumbai’s modern ambition and technological prowess. It’s not just a bridge — it’s a symbol of progress, speed, and the city’s unstoppable energy."
  }
],



"services": [
    {
      "name": "Navi Mumbai to Pune Cab",
      "description": "Reliable cab service from Navi Mumbai to Pune offering spacious and comfortable vehicles for solo travelers, families, and groups. This service includes professional drivers who ensure safe, timely, and stress-free journeys. Perfect for business trips, leisure travel, or weekend getaways, it provides AC and non-AC options, door-to-door pickup, well-maintained vehicles, real-time tracking, flexible scheduling, and transparent fares for a hassle-free experience."
    },
    {
      "name": "Navi Mumbai to Pune Taxi",
      "description": "Convenient taxi service from Navi Mumbai to Pune with multiple vehicle options including Sedans, SUVs, and luxury cars. Suitable for one-way or round trips, this service ensures comfortable travel with AC and non-AC options, professional drivers, punctual pickups, flexible drop points, and safe travel for business commuters, families, and solo travelers alike."
    },
    {
      "name": "Navi Mumbai to Pune Car Hire",
      "description": "Car hire service from Navi Mumbai to Pune offering a range of vehicles including Sedans, SUVs, and luxury cars for personalized and long-distance travel. Ideal for business trips, family journeys, and sightseeing tours, the service includes professional drivers, AC/non-AC options, customizable pickup and drop locations, and reliable, comfortable, and secure travel experience for every passenger."
    },
    {
      "name": "Navi Mumbai to Pune Innova Cab",
      "description": "Travel from Navi Mumbai to Pune in a spacious and comfortable Innova cab, perfect for families or small groups. The service includes AC vehicles, professional drivers, door-to-door pickup, and flexible timings. Ideal for long-distance travel, sightseeing trips, or business visits, the Innova cab ensures a smooth, safe, and enjoyable journey with modern amenities and transparent pricing."
    },
    {
      "name": "Navi Mumbai to Pune Ertiga Cab",
      "description": "Ertiga cab service from Navi Mumbai to Pune providing comfortable seating for small to medium groups, AC service, and professional drivers. Suitable for family trips, leisure travel, and sightseeing tours, this service guarantees safe, reliable, and stress-free transportation with options for one-way or round trips, real-time tracking, well-maintained vehicles, and convenient online booking."
    },
    {
      "name": "Navi Mumbai to Pune Sedan Cab",
      "description": "Sedan cab service from Navi Mumbai to Pune offering a smooth and comfortable ride for business travelers, couples, or solo passengers. Equipped with AC and optional luxury amenities, professional drivers ensure safe and timely travel. Ideal for airport transfers, city tours, and long-distance journeys, this service guarantees convenience, comfort, and hassle-free travel."
    },
    {
      "name": "Navi Mumbai to Pune One Way Taxi",
      "description": "Affordable one-way taxi service from Navi Mumbai to Pune designed for travelers seeking direct and efficient transport. Professional drivers ensure punctual pickups, safe travel, and comfortable AC or non-AC vehicles. Ideal for business trips, family visits, or leisure travel, this service provides reliable, convenient, and stress-free transportation without unnecessary delays."
    },
    {
      "name": "Navi Mumbai to Pune Drop Cab",
      "description": "Drop cab service from Navi Mumbai to Pune offering point-to-point travel with AC and non-AC options. Professional drivers ensure a safe, comfortable, and timely journey, making it perfect for long-distance travel, sightseeing trips, or business visits. Flexible drop points, well-maintained vehicles, and transparent fare options make it a convenient and reliable choice."
    },
    {
      "name": "Navi Mumbai to Pune Luxury Cab",
      "description": "Premium luxury cab service from Navi Mumbai to Pune with top-class vehicles, AC service, and professional chauffeurs. Perfect for business executives, couples, or families seeking a high-end, stress-free travel experience. The service offers door-to-door pickup, comfortable seating, optional amenities, and flexible scheduling for a smooth and enjoyable journey."
    },
    {
      "name": "Navi Mumbai to Pune Outstation Cab",
      "description": "Outstation cab service from Navi Mumbai to Pune offering long-distance travel with comfortable vehicles, professional drivers, and safety-focused services. Includes tolls, driver allowances, and flexible pickup/drop locations. Ideal for families, groups, and business trips, ensuring reliable, timely, and comfortable transport over extended distances."
    },
    {
      "name": "Affordable Navi Mumbai to Pune Cab",
      "description": "Budget-friendly cab service from Navi Mumbai to Pune providing AC and non-AC options for cost-effective and comfortable travel. Professional drivers ensure punctuality, safety, and a smooth journey for families, groups, and solo travelers. Transparent fares, flexible bookings, and reliable vehicles make it a perfect choice for affordable long-distance transport."
    },
    {
      "name": "Navi Mumbai to Pune AC Cab",
      "description": "AC cab service from Navi Mumbai to Pune offering a cool and comfortable journey with professional drivers, modern vehicles, and safe travel practices. Suitable for families, groups, or solo travelers, this service ensures a smooth and enjoyable ride with flexible pickup points, punctual service, and door-to-door convenience."
    },
    {
      "name": "Navi Mumbai to Pune Online Booking",
      "description": "Book your Navi Mumbai to Pune cab online instantly with multiple vehicle options, secure payment methods, and transparent fares. Perfect for hassle-free one-way or round trips, this service offers professional drivers, real-time tracking, safe travel, and flexible scheduling, making your long-distance journey convenient, comfortable, and reliable."
    },
    {
      "name": "Navi Mumbai to Pune Travel Service",
      "description": "Comprehensive travel service from Navi Mumbai to Pune including cabs, drop services, luxury options, and professional drivers. Ideal for business travel, family trips, or leisure tours, this service ensures safe, comfortable, and stress-free transportation with well-maintained vehicles, flexible pickup/drop locations, and reliable travel support throughout the journey."
    },
    {
      "name": "Navi Mumbai to Pune Cab near Me",
      "description": "Find Navi Mumbai to Pune cabs near your location for quick and convenient booking. Professional drivers, AC and luxury vehicle options, and reliable services ensure a hassle-free journey for families, groups, or solo travelers. Door-to-door pickup, real-time tracking, and safe travel make it the most convenient choice for your trip."
    }
  ],
  "tableData": [
    ["Navi Mumbai to Pune Cab", "Navi Mumbai to Pune Taxi"],
    ["Navi Mumbai to Pune Car Hire", "Navi Mumbai to Pune Innova Cab"],
    ["Navi Mumbai to Pune Ertiga Cab", "Navi Mumbai to Pune Sedan Cab"],
    ["Navi Mumbai to Pune One Way Taxi", "Navi Mumbai to Pune Drop Cab"],
    ["Navi Mumbai to Pune Luxury Cab", "Navi Mumbai to Pune Outstation Cab"],
    ["Affordable Navi Mumbai to Pune Cab", "Navi Mumbai to Pune AC Cab"],
    ["Navi Mumbai to Pune Online Booking", "Navi Mumbai to Pune Travel Service"],
    ["Navi Mumbai to Pune Cab near Me", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Navi Mumbai to Pune Cab Service",
    "WhyChoosedescription": "Sai Trupti Cabs Pvt Ltd provides dependable and comfortable cab services from Navi Mumbai to Pune—ideal for business travel, airport transfers or leisure trips."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Our one‑way fares from Navi Mumbai to Pune start from approx. **₹1,615** for a hatchback, and around **₹2,149–₹2,499** for a sedan. :contentReference[oaicite:3]{index=2} :contentReference[oaicite:8]{index=1}"
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs or premium cars to suit your group size, luggage and comfort preferences for the Navi Mumbai‑to‑Pune route. :contentReference[oaicite:2]{index=2}"
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and skilled drivers are familiar with the Navi Mumbai to Pune route, ensuring a safe, smooth and timely journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We provide convenient pickups in Navi Mumbai (city area, airport or suburbs) and drop‑offs in Pune (city, airport, station) as per your preference."
  },
  {
    "WhyChooseheading": "Clean, Well‑Maintained Vehicles",
    "WhyChoosedescription": "All our vehicles are regularly serviced, sanitized and maintained to ensure comfort and reliability on the one‑way trip from Navi Mumbai to Pune."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist with bookings, itinerary changes or travel queries for your Navi Mumbai to Pune cab."
  },
  {
    "WhyChooseheading": "Hassle‑Free Booking Process",
    "WhyChoosedescription": "Book your Navi Mumbai to Pune cab easily via call, WhatsApp or our website—with instant confirmation and prompt vehicle dispatch."
  }
]























  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Navi Mumbai to Pune cab services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable cab services from Navi Mumbai to Pune for one way, round trip, and group travel.',
  },
  {
    question: 'How can I book a cab from Navi Mumbai to Pune with Sai Trupti Cabs?',
    answer: 'You can easily book your Navi Mumbai to Pune cab through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of cabs are available from Navi Mumbai to Pune?',
    answer: 'We offer hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and luxury cabs to suit your travel needs, group size, and budget.',
  },
  {
    question: 'Are the drivers experienced for Navi Mumbai to Pune trips?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in long-distance travel, ensuring a safe and comfortable journey.',
  },
  {
    question: 'Can I hire a cab from Navi Mumbai to Pune for family or group trips?',
    answer: 'Certainly. Our cab services cater to family trips, group tours, and corporate travel from Navi Mumbai to Pune.',
  },
  {
    question: 'Is the Navi Mumbai to Pune cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab services from Navi Mumbai to Pune for your convenience and flexible travel plans.',
  },
  {
    question: 'What are the Navi Mumbai to Pune cab fares?',
    answer: 'Our cab fares start from ₹2,500 for sedans, ₹3,000–₹4,000 for SUVs and Innova Crysta, depending on vehicle type, group size, and travel requirements.',
  },
  {
    question: 'What payment options are accepted for Navi Mumbai to Pune cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets for hassle-free transactions.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Navi Mumbai to Pune cabs?',
    answer: 'All vehicles are sanitized before every trip, and our drivers follow strict hygiene and safety measures to ensure a secure journey.',
  },
  {
    question: 'Is customer support available during the Navi Mumbai to Pune cab ride?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your Navi Mumbai to Pune cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sandeep Sharma',
    feedback: 'I booked a cab from Navi Mumbai to Pune with Sai Trupti Cabs. The ride was comfortable, and the driver was very professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Mehta',
    feedback: 'Sai Trupti Cabs provided excellent service for our Navi Mumbai to Pune trip. Smooth journey and punctual driver.',
    rating: 5,
  },
];

































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai to Pune Cab",
  "image": "https://saitrupticabs.com/assets/images/pune-to-shirdi-cab.jpg",
  "description": "Book Navi Mumbai to Pune Cab with Sai Trupti Cabs for a safe, comfortable, and affordable journey. Choose AC sedans, SUVs, or Innova for one-way, round-trip, or outstation travel with verified drivers and 24/7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "15864"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1999",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/navi-mumbai-to-pune-cab"
  }
};






  return (
    <div>
      <Helmet>
  <title>Navi Mumbai to Pune Cab | Safe & Comfortable | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book Navi Mumbai to Pune Cab with Sai Trupti Cabs for a safe, comfortable, and affordable journey. Choose AC sedans, SUVs, or Innova for one-way, round-trip, or outstation travel with verified drivers and 24/7 online booking." 
  />
  <meta 
    name="keywords" 
    content="Navi Mumbai to Pune Cab, Navi Mumbai to Pune Taxi, Navi Mumbai to Pune Car Hire, Navi Mumbai to Pune Innova Cab, Navi Mumbai to Pune Ertiga Cab, Navi Mumbai to Pune Sedan Cab, Navi Mumbai to Pune One Way Taxi, Navi Mumbai to Pune Drop Cab, Navi Mumbai to Pune Luxury Cab, Navi Mumbai to Pune Outstation Cab, Affordable Navi Mumbai to Pune Cab, Navi Mumbai to Pune AC Cab, Navi Mumbai to Pune Online Booking, Navi Mumbai to Pune Travel Service, Navi Mumbai to Pune Cab near Me" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/63.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Navimumbaitopunecabs;